export default __webpack_public_path__ + "static/media/duster-gallery-2.40bdfa98.jpg";